// The caller's email exactly as firestore.rules works it out in callerEmail():
// the trovexEmail claim when it is set, otherwise the email only when it is
// verified, lowercased (the rule lowercases and does not trim). eshot_sends
// creates must write createdBy as this value, or the create rule refuses
// anyone whose Trovex email differs from their account email (hand-off
// h67397abc). createdBy picks whose signature, sender name and files a send
// uses, so it is only ever the caller's own.
export function ruleCallerEmail(claims) {
  const trovex = claims?.trovexEmail;
  if (typeof trovex === 'string' && trovex !== '') return trovex.toLowerCase();
  if (claims?.email_verified === true && typeof claims.email === 'string' && claims.email !== '') {
    return claims.email.toLowerCase();
  }
  return '';
}

// Reads the signed-in user's token claims and returns ruleCallerEmail(claims).
export async function currentCallerEmail(auth) {
  const user = auth?.currentUser;
  if (!user) return '';
  const { claims } = await user.getIdTokenResult();
  return ruleCallerEmail(claims);
}
